export default __webpack_public_path__ + "static/media/ic_arrow_left_black.2abf23a5.svg";